/**
 * A general response exception.
 * Use .message for the exception message.
 * Use .response for the complete response.
 */
export class ResponseError extends Error {
    readonly response: Response

    constructor(message: string, response: Response) {
        super(message)
        this.response = response
    }
}
